import { t } from "@travily/i18n";
import { Icon, type IconName } from "@ui/components/Icon";
import { ToggleChip, ToggleChipGroup } from "@ui/components/ToggleChip";
import { keysToArray } from "@ui/lib/selection";
import type { Selection } from "@ui/primitives/shared";
import { KOPPEN_MAIN_CLASSES, type KoppenMainClass } from "../../../filter-values";

export type { KoppenMainClass };

// i18n-tasks-use t('components.views.destinations.search.koppen_tropical')
// i18n-tasks-use t('components.views.destinations.search.koppen_dry')
// i18n-tasks-use t('components.views.destinations.search.koppen_temperate')
// i18n-tasks-use t('components.views.destinations.search.koppen_continental')
// i18n-tasks-use t('components.views.destinations.search.koppen_polar')
const OPTIONS: { id: KoppenMainClass; labelKey: string; icon: IconName }[] = [
  { id: "A", labelKey: "components.views.destinations.search.koppen_tropical", icon: "palmTree" },
  { id: "B", labelKey: "components.views.destinations.search.koppen_dry", icon: "cactus" },
  { id: "C", labelKey: "components.views.destinations.search.koppen_temperate", icon: "oliveBranch" },
  { id: "D", labelKey: "components.views.destinations.search.koppen_continental", icon: "acorn" },
  { id: "E", labelKey: "components.views.destinations.search.koppen_polar", icon: "snowflake" },
];

export interface KoppenFilterProps {
  onChange: (classes: KoppenMainClass[]) => void;
  value: KoppenMainClass[];
}

export function KoppenFilter({ onChange, value }: KoppenFilterProps) {
  const handleSelectionChange = (keys: Selection) => {
    onChange(keysToArray(keys, () => [...KOPPEN_MAIN_CLASSES]) as KoppenMainClass[]);
  };

  return (
    <ToggleChipGroup
      aria-label={t("components.views.destinations.search.koppen_label")}
      className="grid-cols-5"
      onSelectionChange={handleSelectionChange}
      selectedKeys={new Set(value)}
      selectionMode="multiple"
    >
      {OPTIONS.map((option) => (
        <ToggleChip className="text-xs" id={option.id} key={option.id}>
          <Icon name={option.icon} size="32" />
          <span>{t(option.labelKey)}</span>
        </ToggleChip>
      ))}
    </ToggleChipGroup>
  );
}
